var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticClass:"custom-access-title"},[_vm._v("\n      New Access Request for "+_vm._s(_vm.userDetails.firstName)+" "+_vm._s(_vm.userDetails.lastName)+"\n    ")])],1),_vm._v(" "),_c('hr',{staticClass:"solid py-1"}),_vm._v(" "),_c('person-details')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }